module.exports = "/fonts/glyphicons-halflings-regular.eot";